import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

const CardFeatureBody = ({
  data: { body, header, image, link, number },
  long = false,
  options = {},
}) => {
  const { feature = null } = options;
  return (
    <div className={`feature-body ${long ? 'long' : ''}`}>
      <div className={`feature ${long ? 'long' : ''}`}>
        {feature === 'numbered' && (
          <div className={`numbered ${long ? 'long' : ''}`}>{number}</div>
        )}
        {feature === 'image' && (
          <div className={`image ${long ? 'long' : ''}`}>
            <GatsbyImage alt="feature" image={getImage(image)} />
          </div>
        )}
      </div>
      <div className={`content ${long ? 'long' : ''}`}>
        <div className="header">{header}</div>
        <div className="snippet">{body}</div>
        {link && (
          <div className="link">
            <Link to={`${link.url}/`}>{link.title}</Link>
          </div>
        )}
      </div>
    </div>
  );
};

CardFeatureBody.propTypes = {
  data: PropTypes.object,
  long: PropTypes.bool,
  options: PropTypes.object,
};

export default CardFeatureBody;
